import api from "../api";
import { errorManager } from "../util";
import * as jose from 'jose'



export const getTasks= async (controller, queryObject, callBack)=>{
    document.body.className='loading';

    const API_KEY= process.env.REACT_APP_API_KEY;
    const secret = new TextEncoder().encode(
        API_KEY
      );
    const token =  await new jose.SignJWT({ id:0, Username:`${JSON.parse(localStorage.getItem('accessInfo'))?.account.username}`,Password:"",isActive:false})
        .setProtectedHeader({ alg: "HS256" })
        .setExpirationTime('1d')
        .sign(secret);
    
    //alert(token);
    console.log("token", token);
    //acescobar@ayesa.com
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    let resp = await api.post(controller, queryObject)
    .then(response=>{
        if (callBack!==undefined){
            callBack(response.data,null);
        }
        document.body.className='';
        return response.data;
    }).catch(error=>{
        if (callBack!==undefined){
            error=errorManager(error);
            callBack(null,error);
            /*let respTest = {
                "asignaciones": null,
                "codigoRetorno": 0,
                "textoRetorno": "ERROR! : Sin resultado IA",
                "iduser": 0,
                "horasCalendario": 8.5
              }
              callBack(respTest,null);*/
            /*let respTest = `{
                "asignaciones": [
                    {
                        "codigoProyecto": 12920,
                        "descripcionProyecto": "p04/SmartTasking",
                        "codigoIssue": 464261,
                        "descripcionIssue": "Tarea SmartTasking",
                        "idActivity": 0,
                        "propuesto": 35.0,
                        "horaReales": [
                            {
                                "id": 2907223,
                                "hours": 4.25,
                                "comments": "",
                                "spent_on": "2022-09-13T00:00:00",
                                "activity": {
                                    "id": 40,
                                    "name": "Horas con normalidad"
                                },
                                "custom_fields": [
                                    {
                                        "id": 111,
                                        "name": "ESPECIALIDAD",
                                        "value": ""
                                    },
                                    {
                                        "id": 110,
                                        "name": "IDSAP",
                                        "value": ""
                                    },
                                    {
                                        "id": 208,
                                        "name": "Localización",
                                        "value": "1337"
                                    }
                                ]
                            },
                            {
                                "id": 2907221,
                                "hours": 4.0,
                                "comments": "",
                                "spent_on": "2022-09-12T00:00:00",
                                "activity": {
                                    "id": 40,
                                    "name": "Horas con normalidad"
                                },
                                "custom_fields": [
                                    {
                                        "id": 111,
                                        "name": "ESPECIALIDAD",
                                        "value": ""
                                    },
                                    {
                                        "id": 110,
                                        "name": "IDSAP",
                                        "value": ""
                                    },
                                    {
                                        "id": 208,
                                        "name": "Localización",
                                        "value": "1337"
                                    }
                                ]
                            },
                            {
                                "id": 2907213,
                                "hours": 0,
                                "comments": null,
                                "spent_on": "2022-09-08T00:00:00",
                                "activity": {
                                    "id": 40,
                                    "name": "Horas con normalidad"
                                },
                                "custom_fields": [
                                    {
                                        "id": 111,
                                        "name": "ESPECIALIDAD",
                                        "value": ""
                                    },
                                    {
                                        "id": 110,
                                        "name": "IDSAP",
                                        "value": ""
                                    },
                                    {
                                        "id": 208,
                                        "name": "Localización",
                                        "value": "1339"
                                    }
                                ]
                            }
                        ],
                        "origen": "IA"
                    },
                    {
                        "codigoProyecto": 12920,
                        "descripcionProyecto": "p04/SmartTasking",
                        "codigoIssue": 464264,
                        "descripcionIssue": "Tarea SmartTasking2",
                        "idActivity": 0,
                        "propuesto": 35.0,
                        "horaReales": [],
                        "origen": "IA"
                    },
                    {
                        "codigoProyecto": 12920,
                        "descripcionProyecto": "p04/SmartTasking",
                        "codigoIssue": 464265,
                        "descripcionIssue": "Tarea SmartTasking3",
                        "idActivity": 0,
                        "propuesto": 35.0,
                        "horaReales": [],
                        "origen": "IA"
                    }
                ],
                "codigoRetorno": 1,
                "textoRetorno": "OK!",
                "iduser": 7396,
                "horasCalendario": 8.75
            }`;
            respTest = JSON.parse(respTest);*/
            document.body.className='';
            //callBack(respTest,null);
        }
        document.body.className='';
        return null;
    });
    return resp;
}

export const setTask= async (controller, queryObject, callBack)=>{
    document.body.className='loading';

    const API_KEY= process.env.REACT_APP_API_KEY;
    const secret = new TextEncoder().encode(
        API_KEY
      );
    const token =  await new jose.SignJWT({ id:0, Username:`${JSON.parse(localStorage.getItem('accessInfo'))?.account.username}`,Password:"",isActive:false})
        .setProtectedHeader({ alg: "HS256" })
        .setExpirationTime('1d')
        .sign(secret);
    
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    let resp = await api.post(controller, queryObject)
    .then(response=>{
        if (callBack!==undefined){
            callBack(response.data,null);
        }
        document.body.className='';
        return response.data;
    }).catch(error=>{
        if (callBack!==undefined){
            callBack(null,error);
        }
        document.body.className='';
        return null;
    });
    return resp;
}
